import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ElectronicDocumentAcceptance, ElectronicDocument } from 'app/models'
import { ApiService } from './api.service'
import { Mapper } from './mapper.service'
import { Store } from './store'

@Injectable({
  providedIn: 'root'
})
export class ElectronicDocumentAcceptanceService extends Store<ElectronicDocumentAcceptance[]> {

  constructor(private api: ApiService) {
    super(null)
  }

  public findCurrent(electronic_document_id?: string): void {
    const params = electronic_document_id ? { electronic_document_id } : { }
    this.api.get('v3/electronic_documents/acceptances/mine', { params })
      .subscribe(
        (data: any) => {
          const acceptances = Mapper.asArray<ElectronicDocumentAcceptance>(data.result, ElectronicDocumentAcceptance)
          this.subject.next(acceptances)
        }
      )
  }

  public create(electronicDocumentId: string, personaId: number, versionNumber: number): Observable<any> {
    return this.api.post('v3/electronic_documents/acceptances', {
      electronic_document_id: electronicDocumentId,
      persona_id: personaId,
      version_number: versionNumber
    })
  }

  public getNextUnsignedElectronicDocument(
    personaId: number,
    electronicDocuments: ElectronicDocument[],
    acceptances: ElectronicDocumentAcceptance[]
  ): ElectronicDocument {
    if (!electronicDocuments) {
      return null
    }
    return electronicDocuments.find((ed: ElectronicDocument) =>
      acceptances.findIndex((a: ElectronicDocumentAcceptance) => a.electronic_document_id === ed.id && a.persona_id === personaId) === -1
    )
  }

  public sync(
    personaId: number,
    bossOrganizationId: number
  ): void {
    this.api.post('v3/electronic_documents/acceptances/sync', {
      persona_id: personaId,
      boss_organization_id: bossOrganizationId
    }).subscribe(() => { })
  }
}
